// extracted by mini-css-extract-plugin
module.exports = {"gvItems":"GVItems_gvItems__W4e4_","itemOuter":"GVItems_itemOuter__kGZ9M","item":"GVItems_item__93wO0"};